// Dependencies
import React from "react";

// Material Components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

// Styles
import { useStyles } from "./VehicleCardDesktop.styles";

const VehicleCardDesktopSkeleton = () => {
  const classes = useStyles();
  return (
    <Grid item xs={12} data-aos="fade-up" data-cy="vehicle-card-skeleton">
      <Card className={classes.root}>
        <div className={classes.imageContainer}>
          <Skeleton variant="rectangular" width={300} height={200} />
        </div>
        <div className={classes.details}>
          <CardContent className={classes.mainContent}>
            <Skeleton>
              <Typography
                variant="h2"
                className={classes.carTitle}
                data-cy="vehicle-card-year-make-model"
              >
                Car name
              </Typography>
            </Skeleton>
            <Skeleton>
              <Typography
                component="h3"
                variant="h5"
                className={classes.carDealership}
                data-cy="dealership-name"
              >
                image Sample dealership name
              </Typography>
            </Skeleton>
            <Skeleton>
              <Typography
                component="h3"
                variant="h5"
                className={classes.carDealership}
                data-cy="dealership-name"
              >
                image 10000kms
              </Typography>
            </Skeleton>
          </CardContent>
          <div className="flexGrow" />
          <div className={classes.bottomContent}>
            <div className="flexGrow" />
            <Skeleton>
              <Typography variant="h3">$30,000</Typography>
            </Skeleton>
          </div>
        </div>
      </Card>
    </Grid>
  );
};

export default VehicleCardDesktopSkeleton;
